import React from 'react';

export const FileIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M0 0H7V5H12V16H0V0ZM12 4H8V0L12 4Z"
        fill="currentColor"
      />
    </svg>
  );
};
